export enum FxLifeCycleEventType {
  UNKNOWN,
  RECEIVED,
  PENDING,
  SI_REQUIRED,
  PRICED,
  FILL_EXPIRED,
  FILL_ERROR,
  TI_REQUIRED,
  ACTIVE,
  ACTIVATING,
  GFT_ACTIVATE,
  TRADE_CANCELLED,
  CANCELLED,
  PENDING_CANCELLED,
  PENDING_CANCELLATION,
  CANCELLATION_REJECT,
  FILLED_PARTIAL,
  FILLED,
  TRIGGERED,
  EXPIRED,
  LOCKED,
  UNLOCKED,
  REJECTED,
  DONT_KNOW,
  FAILED,
  GAMMA,
  GAMMA_PENDING,
  DELETED,
  MODIFICATION_INFO,
  SUSPENDING,
  EXPIRING,
  SUSPENDED,
  CREDIT_UPDATE,
  REPLACED,
  PENDING_REPLACE,
  PAUSED,
  RESUMED,
  SAVED,
  SAVED_DELETED,
  FILL_MATCH,
  FILL_UPDATE,
  MATCHED,
  BULK_REJECTED,
  FILLING,
  UNSOLICITED_PAUSE,
  UNSOLICITED_RESUME,
  UNSOLICITED_CANCEL,
  FILL_PENDING,
  FILL_CALCULATED,
  PENDING_FWDS,
  EXPIRY_PENDING_FWDS,
  CANCEL_PENDING_FWDS,
  BULK_PREVISIBILITY,
  NETTING,
}

export namespace FxLifeCycleEventType {
  let elements = [
    FxLifeCycleEventType.UNKNOWN,
    FxLifeCycleEventType.RECEIVED,
    FxLifeCycleEventType.PENDING,
    FxLifeCycleEventType.SI_REQUIRED,
    FxLifeCycleEventType.PRICED,
    FxLifeCycleEventType.FILL_EXPIRED,
    FxLifeCycleEventType.FILL_ERROR,
    FxLifeCycleEventType.TI_REQUIRED,
    FxLifeCycleEventType.ACTIVE,
    FxLifeCycleEventType.ACTIVATING,
    FxLifeCycleEventType.GFT_ACTIVATE,
    FxLifeCycleEventType.TRADE_CANCELLED,
    FxLifeCycleEventType.CANCELLED,
    FxLifeCycleEventType.PENDING_CANCELLED,
    FxLifeCycleEventType.PENDING_CANCELLATION,
    FxLifeCycleEventType.CANCELLATION_REJECT,
    FxLifeCycleEventType.FILLED_PARTIAL,
    FxLifeCycleEventType.FILLED,
    FxLifeCycleEventType.TRIGGERED,
    FxLifeCycleEventType.EXPIRED,
    FxLifeCycleEventType.LOCKED,
    FxLifeCycleEventType.UNLOCKED,
    FxLifeCycleEventType.REJECTED,
    FxLifeCycleEventType.DONT_KNOW,
    FxLifeCycleEventType.FAILED,
    FxLifeCycleEventType.GAMMA,
    FxLifeCycleEventType.GAMMA_PENDING,
    FxLifeCycleEventType.DELETED,
    FxLifeCycleEventType.MODIFICATION_INFO,
    FxLifeCycleEventType.SUSPENDING,
    FxLifeCycleEventType.EXPIRING,
    FxLifeCycleEventType.SUSPENDED,
    FxLifeCycleEventType.CREDIT_UPDATE,
    FxLifeCycleEventType.REPLACED,
    FxLifeCycleEventType.PENDING_REPLACE,
    FxLifeCycleEventType.PAUSED,
    FxLifeCycleEventType.RESUMED,
    FxLifeCycleEventType.SAVED,
    FxLifeCycleEventType.SAVED_DELETED,
    FxLifeCycleEventType.FILL_MATCH,
    FxLifeCycleEventType.FILL_UPDATE,
    FxLifeCycleEventType.MATCHED,
    FxLifeCycleEventType.BULK_REJECTED,
    FxLifeCycleEventType.FILLING,
    FxLifeCycleEventType.UNSOLICITED_PAUSE,
    FxLifeCycleEventType.UNSOLICITED_RESUME,
    FxLifeCycleEventType.UNSOLICITED_CANCEL,
    FxLifeCycleEventType.FILL_PENDING,
    FxLifeCycleEventType.FILL_CALCULATED,
    FxLifeCycleEventType.PENDING_FWDS,
    FxLifeCycleEventType.EXPIRY_PENDING_FWDS,
    FxLifeCycleEventType.CANCEL_PENDING_FWDS,
    FxLifeCycleEventType.BULK_PREVISIBILITY,
    FxLifeCycleEventType.NETTING,
  ];
  let alias = "com.bcdfx.api.event.FxLifeCycleEventType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
